import React, { ReactNode } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

interface SummaryTableProps {
  columns: string[];
  children: ReactNode | ReactNode[];
}

export const SummaryTable = ({ columns, children }: SummaryTableProps) => (
  <TableContainer variant="outlined" component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map((c, index) => (
            <TableCell key={c + index}>{c}</TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>{children}</TableBody>
    </Table>
  </TableContainer>
);
